// extracted by mini-css-extract-plugin
export default {"body":"TransferOwnershipModal_body__AWrzL","buttons":"TransferOwnershipModal_buttons__K77Sd","disabled":"TransferOwnershipModal_disabled__L5h7J"};